/* ============================================================
   PBK ルース一覧 → 商品詳細 quick-view モーダル遷移
   一覧のカードクリックで、詳細ページ本体をフルロードせずモーダルで開く。
   - fetch('/products/<handle>') → .pbk-pdp を抽出しオーバーレイへ注入
   - window.PBKProductLoose.init(injected) で gallery/consent/tabs/zoom/carousel を配線
   - history.pushState で URL を詳細ページへ切替。× / ESC / scrim / 戻る で閉じ、一覧へ戻る
   - リロード時は URL=詳細ページ = サーバーが通常フルページを描画（本 JS は不関与）
   レイヤー/スクロール設計（CL #114 / #109 / #152）: オーバーレイは固定・パネルも固定で
   スクロールするのはパネルの中身だけ。背面ページは .pbk-noscroll でロック（下記 lockBody）。
   ============================================================ */
(function () {
  'use strict';

  var overlay = null;
  var panel = null;
  var currentHandle = null;
  var injectedModals = [];
  var lastFocus = null;
  var loadReq = 0;          /* fetch 世代カウンタ（連打・キャンセルで前世代を無効化） */
  var loadAbort = null;     /* 進行中 fetch の AbortController（未対応環境は null） */
  var loadingHandle = null; /* 読み込み中のハンドル（同一カード連打の無視用） */

  function getOverlay() {
    if (overlay) return overlay;
    overlay = document.getElementById('PbkQuickview');
    panel = overlay ? overlay.querySelector('[data-pbk-qv-panel]') : null;
    return overlay;
  }

  function handleFromUrl(url) {
    var m = String(url).split('?')[0].replace(/\/$/, '').match(/\/products\/([^/]+)$/);
    return m ? m[1] : null;
  }

  /* 注入した zoom/notice モーダルを DOM から完全に除去する。
     ModalDialog（global.js）は connectedCallback で自分を document.body へ移すため、
     panel 配下を探しても既に居ない。取りこぼすと body 末尾に積み上がり、
     id（PbkZoomModal-/PbkNoticeModal- + section.id）は商品によらず同じなので
     document.querySelector が常に「最初に開いた商品」のモーダルを掴んでしまう。 */
  function cleanupModals() {
    injectedModals.forEach(function (m) { if (m && m.parentNode) m.parentNode.removeChild(m); });
    injectedModals = [];
    /* 取りこぼし（過去の堆積・別経路で移動した分）も id 前方一致で掃除 */
    [].slice
      .call(document.querySelectorAll('body > modal-dialog[id^="PbkZoomModal-"], body > modal-dialog[id^="PbkNoticeModal-"]'))
      .forEach(function (m) { if (m.parentNode) m.parentNode.removeChild(m); });
  }

  /* CL #199: パネル上端は Figma 実測の固定値（PC 19px / SP 20px・pbk-pdp-quickview.css）になったため
     ヘッダー高さの計測（旧 syncHeaderOffset → --pbk-qv-top）は不要。
     ヘッダーは scrim(100) より下（50）でシート/黒透過の背後に沈む。 */

  /* 背面ページのスクロールロック。body.overflow-hidden だけでは iOS Safari で背面が動くため、
     一覧のフィルター窓と同じ .pbk-noscroll（html/body overflow:hidden + body position:fixed）を流用し、
     解除時にスクロール位置を復元する（クラス定義は pbk-collection-loose/jewelry.css）。
     フィルター窓が既にロック中の時は触らない（相手の復元値を壊さないため） */
  var lockedY = 0;
  var didLock = false;
  /* ロック中は body が position:fixed で window.scrollY=0 になるため、pushState 時に
     履歴エントリへ「スクロール位置 0」が保存される。閉じ時の history.back() で
     ブラウザのネイティブ scroll restoration がその 0 を復元し、unlockBody の
     scrollTo(0, lockedY) を上書きして一覧が最上部へ飛ぶ。
     → quick-view 表示中だけ history.scrollRestoration を manual にして
     ネイティブ復元を止め、閉じ（履歴の戻り）完了後に元の値へ戻す */
  var prevScrollRestoration = null;
  function holdScrollRestoration() {
    if (prevScrollRestoration !== null || !('scrollRestoration' in window.history)) return;
    prevScrollRestoration = window.history.scrollRestoration;
    try { window.history.scrollRestoration = 'manual'; } catch (e) {}
  }
  function releaseScrollRestoration() {
    if (prevScrollRestoration === null) return;
    var mode = prevScrollRestoration;
    prevScrollRestoration = null;
    try { window.history.scrollRestoration = mode; } catch (e) {}
  }
  function lockBody() {
    if (didLock || document.documentElement.classList.contains('pbk-noscroll')) return;
    holdScrollRestoration();
    lockedY = window.pageYOffset || document.documentElement.scrollTop || 0;
    document.documentElement.classList.add('pbk-noscroll');
    document.body.style.top = -lockedY + 'px';
    didLock = true;
  }
  function unlockBody() {
    if (!didLock) return;
    didLock = false;
    document.documentElement.classList.remove('pbk-noscroll');
    document.body.style.top = '';
    window.scrollTo(0, lockedY);
    /* × 経由はこの後 history.back() が走る（state.pbkqv がまだ残っている）ので
       manual を維持し、popstate 側で解除する。戻り先へ到着済み／未 push（読み込み
       キャンセル）の時だけここで解除。ネイティブ復元ステップより後にするため 1 タスク遅延 */
    if (!(window.history.state && window.history.state.pbkqv)) {
      setTimeout(releaseScrollRestoration, 0);
    }
  }

  /* × の右アキをパネルの「見えている中身の右端」から測るための補正値。
     CL #225「close ボタンの位置をデザインに合わせる」: Figma pc/loose/detail 3215:99897 は
     × を右 40px（フレーム右端 1440 → x1368〜1400）に置く。実装の × は position:fixed で
     ウィンドウ右端基準のため、パネル（.pbk-qv__panel は overflow-y:auto）にクラシックな
     スクロールバー（OS 設定「スクロールバーを常に表示」= 15px 相当）が出る環境では
     見た目の右アキが 40 − スクロールバー幅 に縮む。その差分を CSS 変数で足し戻す。
     オーバーレイ型スクロールバー（既定）では 0 なので挙動は変わらない。 */
  function syncPanelScrollbar() {
    if (!overlay || !panel) return;
    var sbw = panel.offsetWidth - panel.clientWidth;
    if (!isFinite(sbw) || sbw < 0) sbw = 0;
    overlay.style.setProperty('--pbk-qv-sbw', sbw + 'px');
  }

  function doClose(fromPop) {
    if (!overlay || !overlay.classList.contains('is-open')) return;
    overlay.classList.remove('is-open');
    overlay.setAttribute('hidden', '');
    if (panel) panel.innerHTML = '';
    cleanupModals();
    unlockBody();
    document.body.classList.remove('pbk-qv-open');
    currentHandle = null;
    if (lastFocus && lastFocus.focus) { try { lastFocus.focus(); } catch (e) {} }
    /* × / ESC / scrim 経由なら履歴を1つ戻して一覧 URL に復帰（popstate 経由なら既に戻っている） */
    if (!fromPop && window.history.state && window.history.state.pbkqv) {
      window.history.back();
    }
  }

  function requestClose() {
    if (cancelLoad()) return; /* 読み込み中なら取得を中断（履歴は未 push → 戻さない） */
    doClose(false);
  }

  /* ---------- ローディング（クリック直後〜注入完了） ---------- */
  function startLoading(handle) {
    loadingHandle = handle;
    overlay.removeAttribute('hidden');
    overlay.classList.add('is-loading');
    lockBody(); /* 背面ページのスクロールを止める */
  }
  function endLoading() {
    loadingHandle = null;
    overlay.classList.remove('is-loading');
    if (!overlay.classList.contains('is-open')) {
      overlay.setAttribute('hidden', '');
      unlockBody();
    }
  }
  /* ESC / scrim / 別カードクリックでの取得中断。中断したら true */
  function cancelLoad() {
    if (!overlay || !overlay.classList.contains('is-loading')) return false;
    loadReq++; /* 進行中の then/catch を無効化 */
    if (loadAbort) { try { loadAbort.abort(); } catch (e) {} loadAbort = null; }
    endLoading();
    return true;
  }

  /* push: true = 履歴に1件積む（一覧カードから開くとき）
           'replace' = 履歴を積まず現在のエントリを差し替える
             （CL #223「商品詳細内で別商品に遷移してもモーダル表示を担保する」用。
              モーダル内の遷移で push すると × の history.back() が前の商品へ戻ってしまい
              「いつでも商品一覧に戻れる形」にならないため、常に一覧の1つ手前を維持する）
           false = 履歴を触らない */
  function openFor(handle, url, push) {
    if (!getOverlay() || !panel) { window.location = url; return; }
    if (overlay.classList.contains('is-loading')) {
      if (loadingHandle === handle) return; /* 同じカードの連打は無視 */
      cancelLoad();                         /* 別カードなら前の取得を捨てて張り替え */
    }
    var req = ++loadReq;
    loadAbort = window.AbortController ? new window.AbortController() : null;
    startLoading(handle);
    fetch(url, {
      headers: { 'X-Requested-With': 'pbk-quickview' },
      credentials: 'same-origin',
      signal: loadAbort ? loadAbort.signal : undefined
    })
      .then(function (r) { return r.ok ? r.text() : null; })
      .then(function (html) {
        if (req !== loadReq) return; /* キャンセル済 / 後発クリックに追い越された */
        loadAbort = null;
        /* フォールバックのフルページ遷移中はスピナーを出したままにする */
        if (!html) { window.location = url; return; }
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var pdp = doc.querySelector('.pbk-pdp');
        if (!pdp) { window.location = url; return; }
        /* .pbk-pdp は modal-dialog(zoom/notice)を兄弟に持つ → 併せて抽出注入 */
        var markup = pdp.outerHTML;
        doc.querySelectorAll('modal-dialog[id^="PbkZoomModal-"], modal-dialog[id^="PbkNoticeModal-"]').forEach(function (m) {
          markup += m.outerHTML;
        });

        /* 前の商品のモーダルを先に始末してから注入する。
           残したまま入れると id が重複し（section.id は商品共通）、以降の
           document.querySelector が古い方を掴んで「別商品を開いたのに前の画像が出る」
           「同意してもカートが有効化しない」が起きる */
        cleanupModals();

        panel.innerHTML = markup; /* 再パースで custom element が upgrade */
        /* zoom/notice modal は overlay(z100) の stacking context に閉じ込めると
           overlay 内での相対順位しか持てない → body 直下へ出して z110/120 を素の階層で効かせる。閉じる時に除去。
           ModalDialog は connectedCallback 時点で自ら body へ移動済みなので、
           panel 配下ではなく body 直下から拾う（旧実装はここが常に空で、
           injectedModals が永久に [] のまま＝後始末が効いていなかった） */
        injectedModals = [].slice.call(
          document.querySelectorAll('body > modal-dialog[id^="PbkZoomModal-"], body > modal-dialog[id^="PbkNoticeModal-"]')
        );
        /* 念のため panel 内に残っている個体があれば body へ移してから記録 */
        [].slice.call(panel.querySelectorAll('modal-dialog')).forEach(function (m) {
          document.body.appendChild(m);
          if (injectedModals.indexOf(m) === -1) injectedModals.push(m);
        });

        overlay.removeAttribute('hidden');
        overlay.classList.add('is-open');
        endLoading(); /* 注入完了 → スピナー除去（is-open 済なので scrim は残る） */
        lockBody();
        document.body.classList.add('pbk-qv-open');
        panel.scrollTop = 0; /* スクロールするのはパネルの中身（オーバーレイは固定） */
        syncPanelScrollbar();

        window.pbkCurrentProductHandle = handle; /* Recently の自己除外用（注入時 inline script は非実行） */
        if (window.PBKRecentlyViewed) window.PBKRecentlyViewed.record(handle); /* quick-view 閲覧も履歴へ */
        var injected = panel.querySelector('.pbk-pdp');
        if (window.PBKProductLoose && injected) {
          try { window.PBKProductLoose.init(injected); } catch (e) {}
        }
        /* 注入 PDP の × を quick-view 閉じに配線（フルページ遷移を抑止） */
        var closeBtn = panel.querySelector('[data-pbk-pdp-close]');
        if (closeBtn) {
          closeBtn.addEventListener('click', function (e) { e.preventDefault(); requestClose(); });
        }
        currentHandle = handle;
        if (push === 'replace') {
          try { window.history.replaceState({ pbkqv: handle }, '', url); } catch (e) {}
        } else if (push) {
          try { window.history.pushState({ pbkqv: handle }, '', url); } catch (e) {}
        }
      })
      .catch(function () {
        if (req !== loadReq) return; /* ESC 等でキャンセル済（abort もここへ来る） */
        loadAbort = null;
        window.location = url; /* 遷移までスピナー継続 */
      });
  }

  /* ---------- 一覧カードのクリックを横取り ---------- */
  function onGridClick(e) {
    if (e.defaultPrevented) return;
    if (e.button != null && e.button !== 0) return;
    if (e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return; /* 新規タブ等は通す */
    var link = e.target.closest ? e.target.closest('a.pbk-lcard__link, a.pbk-pcard__link') : null;
    if (!link) return;
    var grid = e.currentTarget;
    if (!grid.contains(link)) return;
    var url = link.getAttribute('href');
    var handle = handleFromUrl(url);
    if (!handle) return;
    e.preventDefault();
    lastFocus = link;
    openFor(handle, url, true);
  }

  function bindGrids() {
    document.querySelectorAll('.pbk-loose-grid').forEach(function (grid) {
      if (grid.dataset.qvBound) return;
      grid.dataset.qvBound = '1';
      grid.addEventListener('click', onGridClick);
    });
  }

  /* ---------- モーダル内の商品リンク（Similar / Same Color / Recently）を横取り ----------
     CL #223「商品詳細内で別商品に遷移してもモーダル表示を担保する（モーダル表示ではなくなるので、
     いつでも商品一覧に戻れる形に）」。
     旧実装はモーダル内のカードリンクを素通しでフルページ遷移させていたため、
     一度別商品へ飛ぶとモーダル文脈（× と一覧への復帰）が失われていた。
     → オーバーレイ内のクリックを委譲で拾い、パネルの中身を差し替える。
     履歴は replace（積まない）＝ × / ESC / scrim / 戻る はいつでも一覧へ復帰する。 */
  function onOverlayClick(e) {
    if (e.defaultPrevented) return;
    if (e.button != null && e.button !== 0) return;
    if (e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return; /* 新規タブ等は通す */
    if (!e.target.closest) return;
    /* 閉じる × は別配線（ここで拾わない） */
    if (e.target.closest('[data-pbk-pdp-close], [data-pbk-qv-close]')) return;
    var link = e.target.closest('a[href*="/products/"]');
    if (!link) return;
    if (link.target && link.target !== '_self') return;
    var handle = handleFromUrl(link.getAttribute('href') || '');
    if (!handle || handle === currentHandle) return;
    e.preventDefault();
    lastFocus = link;
    openFor(handle, link.getAttribute('href'), 'replace');
    if (panel) panel.scrollTop = 0;
  }

  function init() {
    if (!getOverlay()) return;
    bindGrids();
    /* モーダル内の商品リンク → モーダルのまま差し替え（CL #223） */
    overlay.addEventListener('click', onOverlayClick);
    /* scrim（パネル外）クリックで閉じる */
    overlay.addEventListener('click', function (e) { if (e.target === overlay) requestClose(); });
    /* × 閉じるボタン（オーバーレイ固有・任意） */
    var ov = overlay.querySelector('[data-pbk-qv-close]');
    if (ov) ov.addEventListener('click', requestClose);
    /* ESC（読み込み中なら取得キャンセル） */
    document.addEventListener('keyup', function (e) {
      if (e.key !== 'Escape' && e.key !== 'Esc') return;
      if (overlay.classList.contains('is-open') || overlay.classList.contains('is-loading')) requestClose();
    });
    /* 戻る/進む */
    window.addEventListener('popstate', function () {
      var isQv = window.history.state && window.history.state.pbkqv;
      if (!isQv && overlay.classList.contains('is-open')) doClose(true);
      /* quick-view から抜けた（× の history.back() 含む）→ manual 解除。
         ネイティブ復元ステップ後に行うため 1 タスク遅延 */
      if (!isQv) setTimeout(releaseScrollRestoration, 0);
    });
    /* quick-view 表示中のフルページ遷移（フォールバック遷移・リンク遷移）で
       manual が残留しないよう離脱時に解除 */
    window.addEventListener('pagehide', releaseScrollRestoration);
    /* 幅が変わるとパネルのスクロールバー有無も変わりうる → × の右アキ補正を取り直す */
    window.addEventListener('resize', function () {
      if (overlay.classList.contains('is-open')) syncPanelScrollbar();
    });
    /* グリッドは無限スクロールでカードが追加されるが、click はグリッド委譲なので再バインド不要 */
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
